/**
 * The Admin section's palette.
 *
 * One source of truth for the chrome (sidebar, breadcrumb + tab header, page
 * head) and for the screens that sit inside it. The teal family is the app's
 * brand header colour carried down into the section, so the Admin area reads as
 * one surface rather than a grey page hanging under a teal bar.
 *
 * These are now **aliases onto `src/theme/colors.js`** rather than their own
 * hexes — the admin section was already sampled from the same teal, so this
 * just makes the relationship explicit. Add a color to the ramp, not here.
 *
 * `pricingUi.T` is the pricing screen's own palette and still drives its cards
 * and grids; it aliases the same tokens.
 */
import { segTrack, slate, status, teal } from "../../../theme/colors";

export const A = {
  teal: teal[500], // brand surface
  tealDark: teal[600], // action — under white text
  tealDeep: teal[700], // active/selected text
  tealSoft: teal[100], // active tint
  tealSoft2: teal[200], // border on a tinted surface

  bg: segTrack,
  surface: "#FFFFFF",

  ink: "#17222B",
  ink2: "#3D4B57",
  muted: "#69798A",
  faint: "#96A3B0",

  line: slate[200],
  lineStrong: "#CBD5DB",

  ok: status.success.fg,
  okSoft: status.success.bg,
  warn: "#A8620A",

  mono: 'ui-monospace, SFMono-Regular, Menlo, Consolas, "Liberation Mono", monospace',

  shadowSm: "0 1px 2px rgba(23,34,43,.06)",
  shadowMd: "0 4px 16px -2px rgba(23,34,43,.10)",
  shadowLg: "0 14px 36px -8px rgba(23,34,43,.22)",
};

/** Sidebar widths — the expanded panel and the collapsed icon rail. */
export const SIDEBAR_W = 224;
export const RAIL_W = 60;

/**
 * The content column's cap. One number for every admin screen — a page that
 * needs a different width is a design decision, not a per-screen accident.
 */
export const ADMIN_MAX_W = 1800;

/**
 * How far a sticky element inside the admin scroll container sits from its top.
 * The sub-tab strip pins at 0 and everything that has to clear it (the "on this
 * page" rail, a section's `scrollMarginTop`) measures from this.
 */
export const STICKY_TABS_H = 46;

export default A;
